"use strict";
exports.__esModule = true;
exports.RealtimeEvent = void 0;
var RealtimeEvent;
(function (RealtimeEvent) {
    RealtimeEvent["ActualBreakUpdated"] = "actual_break:updated";
    RealtimeEvent["AlertMassRemoved"] = "alert:mass_removed";
    RealtimeEvent["AlertNew"] = "alert:new";
    RealtimeEvent["AlertRemoved"] = "alert:removed";
    RealtimeEvent["AlertUpdateOwner"] = "alert:update_owner";
    RealtimeEvent["AnnouncementNew"] = "announcement:new";
    RealtimeEvent["ApplicationActionDone"] = "application:action:done";
    RealtimeEvent["ApplicationActionProcessDone"] = "application:action:process_done";
    RealtimeEvent["ConversationMessageNew"] = "conversation:message:new";
    RealtimeEvent["ConversationNew"] = "conversation:new";
    RealtimeEvent["ConversationRemoved"] = "conversation:removed";
    RealtimeEvent["ConversationUpdate"] = "conversation:update";
    RealtimeEvent["EmployeeActivityChange"] = "employee:activity_change";
    RealtimeEvent["EmployeeUpdate"] = "employee:update";
    RealtimeEvent["EmployeeUpdateLocation"] = "employee:update_location";
    RealtimeEvent["EtaRecalculateDone"] = "eta_recalculate:done";
    RealtimeEvent["FloatingInventoryAdded"] = "floating_inventory:added";
    RealtimeEvent["FloatingInventoryRemoved"] = "floating_inventory:removed";
    RealtimeEvent["MerchantConfigurationUpdated"] = "merchant_configuration:updated";
    RealtimeEvent["MerchantUpdated"] = "merchant:updated";
    RealtimeEvent["NoteCreated"] = "note:created";
    RealtimeEvent["OptimizationDone"] = "optimization:done";
    RealtimeEvent["OptimizationProgress"] = "optimization:progress";
    RealtimeEvent["ReportExportProgress"] = "report_export_progress";
    RealtimeEvent["RouteOptimizationFinished"] = "route_optimization:finished";
    RealtimeEvent["RunCreated"] = "run:created";
    RealtimeEvent["RunDeleted"] = "run:deleted";
    RealtimeEvent["RunUpdated"] = "run:updated";
    RealtimeEvent["ScanCreated"] = "scan:created";
    RealtimeEvent["ShiftEnded"] = "shift:ended";
    RealtimeEvent["SubscriptionUpdated"] = "subscription_updated";
    RealtimeEvent["TaskBroadcasted"] = "task:broadcasted";
    RealtimeEvent["TaskCancelled"] = "task:canelled";
    RealtimeEvent["TaskDeleted"] = "task:deleted";
    RealtimeEvent["TaskDone"] = "task:done";
    RealtimeEvent["TaskNew"] = "task:new";
    RealtimeEvent["TaskRemoved"] = "task:removed";
    RealtimeEvent["TaskUpdate"] = "task:update";
    RealtimeEvent["TasksMassRemove"] = "tasks:mass_remove";
    RealtimeEvent["TasksReadyToExecute"] = "tasks:ready_to_execute";
    RealtimeEvent["UserAskForLog"] = "user:ask_for_log";
    RealtimeEvent["UserDeleted"] = "user:deleted";
    RealtimeEvent["UserNew"] = "user:new";
    RealtimeEvent["UserRequestRefresh"] = "user:request_refresh";
    RealtimeEvent["VehicleAssigned"] = "vehicle:assigned";
    RealtimeEvent["VehicleRemoved"] = "vehicle:removed";
    RealtimeEvent["VehicleUpdate"] = "vehicle:update";
    RealtimeEvent["VrpAutoDispatchDone"] = "vrp_auto_dispatch:done";
    RealtimeEvent["WayPointCheckin"] = "way_point:checkin";
    RealtimeEvent["WayPointDeleted"] = "way_point:deleted";
    RealtimeEvent["WayPointDone"] = "way_point:done";
    RealtimeEvent["WayPointNew"] = "way_point:new";
    RealtimeEvent["WayPointUpdated"] = "way_point:updated";
    RealtimeEvent["WayPointViewed"] = "way_point:viewed";
    RealtimeEvent["ZipCodesImportDone"] = "zip_codes_import:done";
})(RealtimeEvent = exports.RealtimeEvent || (exports.RealtimeEvent = {}));
//# sourceMappingURL=realtime_event.js.map